import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogOut, LayoutDashboard, GitCompareArrows, Crown } from "lucide-react";

export function Navbar() {
  const { user, subscription, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-oat/80 backdrop-blur-xl border-b border-clay">
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="nav-logo">
          <img src="/scorecaster-logo.png" alt="Scorecaster" className="h-14 w-auto" />
          <span className="font-display font-extrabold text-2xl tracking-tight text-ink hidden sm:block">Scorecaster</span>
        </Link>

        <nav className="flex items-center gap-1 sm:gap-2">
          {user ? (
            <>
              <Link
                to="/dashboard"
                data-testid="nav-dashboard"
                className="flex items-center gap-2 px-3 sm:px-4 py-2 text-sm text-stone hover:text-ink transition-colors duration-300"
              >
                <LayoutDashboard size={16} /> <span className="hidden sm:inline">Dashboard</span>
              </Link>
              <Link
                to="/compare"
                data-testid="nav-compare"
                className="flex items-center gap-2 px-3 sm:px-4 py-2 text-sm text-stone hover:text-ink transition-colors duration-300"
              >
                <GitCompareArrows size={16} /> <span className="hidden sm:inline">Compare</span>
              </Link>
              {subscription?.active ? (
                <Link
                  to="/premium"
                  data-testid="nav-plan-badge"
                  className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-full border border-brand-orange/40 text-brand-orange bg-brand-orange/5"
                >
                  <Crown size={13} /> {subscription.label}
                </Link>
              ) : (
                <Link
                  to="/premium"
                  data-testid="nav-upgrade"
                  className="flex items-center gap-1.5 px-4 py-2 text-sm font-semibold rounded-full bg-brand-orange text-white hover:bg-[#e67e00] transition-colors duration-300"
                >
                  <Crown size={14} /> Upgrade
                </Link>
              )}
              <button
                data-testid="nav-logout"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                className="flex items-center gap-2 px-3 sm:px-4 py-2 text-sm text-stone hover:text-brand-red transition-colors duration-300"
              >
                <LogOut size={16} /> <span className="hidden sm:inline">Logout</span>
              </button>
            </>
          ) : (
            <>
              <Link to="/auth" data-testid="nav-login" className="px-4 py-2 text-sm text-stone hover:text-ink transition-colors duration-300">
                Log in
              </Link>
              <Link
                to="/auth?mode=register"
                data-testid="nav-signup"
                className="px-5 py-2 text-sm font-semibold rounded-full bg-brand-red text-white hover:bg-[#e63f3f] transition-colors duration-300"
              >
                Get started
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
